
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import listado_llamados from './listados/listado-llamados.vue';
    import listado_ventas from './listados/listado-ventas.vue';
    import listado_hoja from './listados/listado-hoja-de-piso.vue';
    import etiquetas_hoja from './listados/etiquetas-hoja-de-piso.vue';
    import envios_hoja from './listados/etiquetas-envio-hoja-de-piso.vue';

    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado_llamados,
            listado_ventas,
            listado_hoja,
            envios_hoja,
            etiquetas_hoja,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        public Abierto: boolean = false;
        public Listados: { Nombre: string; Accion: Function; }[] = [
            { Nombre: 'Listado para llamados postventa', Accion: this.AbrirListadoLlamados },
            { Nombre: 'Listado de ventas', Accion: this.AbrirListadoVentas },
            { Nombre: 'Crear hoja de piso', Accion: this.AbrirHojaDePiso },
            { Nombre: 'Imprimir etiquetas items', Accion: this.AbrirEtiquetasHojaDePiso },
            { Nombre: 'Imprimir etiquetas envios', Accion: this.AbrirEnviosHojaDePiso },
        ];

        public ListadoLlamados: boolean = false;
        public AbrirListadoLlamados() { this.ListadoLlamados = !this.ListadoLlamados; };

        public ListadoVentas: boolean = false;
        public AbrirListadoVentas() { this.ListadoVentas = !this.ListadoVentas; };

        public HojaDePiso: boolean = false;
        public AbrirHojaDePiso() { this.HojaDePiso = !this.HojaDePiso; };

        public EtiquetasHojaDePiso: boolean = false;
        public AbrirEtiquetasHojaDePiso() { this.EtiquetasHojaDePiso = !this.EtiquetasHojaDePiso; };

        public EnviosHojaDePiso: boolean = false;
        public AbrirEnviosHojaDePiso() { this.EnviosHojaDePiso = !this.EnviosHojaDePiso; };

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            await this.Iniciar();
            this.Eventos.push( this.Controlador.onRecargarEstadistica.subscribe( () => { this.Iniciar(); } ) );

        }

        public HojasDePiso: { id: number; }[] = [];
        async Iniciar()
        {
            this.HojasDePiso.clear();
            this.HojasDePiso.push( ... await Pedido.HojaDePisoUltimas() );
        }

        public async DescargarHojaDePiso( item: number )
        {
            Utiles.GenerandoArchivo( true );
            this.Abierto = false;
            let pdf = await Pedido.URLHojaDePiso( item );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la hoja de piso` );

            }
            Utiles.GenerandoArchivo( false );
        }
    }
